/**
 * Phase G.1 — when to refresh architect narrative after assessment changes.
 *
 * @module client/hooks/auditArchitectSync
 */

/**
 * @param {string | null | undefined} previousFp
 * @param {string | null | undefined} nextFp
 */
export function shouldRefreshArchitectForAudit(previousFp, nextFp, { workspaceBootstrapped = false } = {}) {
  const next = nextFp != null ? String(nextFp).trim() : "";
  if (!next) return false;
  const prev = previousFp != null ? String(previousFp).trim() : "";
  if (prev === next) return false;
  if (!prev) return Boolean(workspaceBootstrapped);
  return true;
}

/**
 * Remove prior assessment-scoped architect replies before inserting a fresh narrative.
 *
 * @param {unknown[]} messages
 */
export function withoutAuditNarrativeMessages(messages) {
  if (!Array.isArray(messages)) return [];
  return messages.filter((m) => !(m && typeof m === "object" && m.auditNarrative === true));
}
